import { DefaultService } from '@/services/DefaultService';

export default class RegiaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(regiao) {
        return this._http.post(`${this._env}/regions`, regiao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/regions/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/regions/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column, order, empresas, page = 0, limit = 50, situacao = 2, ...param) {
        return this._http.get(encodeURI(`${this._env}/regions.json?column=${column}&order=${order}&empresas=${empresas}&page=${page}&limit=${limit}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(...param) {
        return this._http.get(encodeURI(`${this._env}/getcombo/regions.json?param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(regiao) {
        return this._http.post(`${this._env}/vendas/regions/updatesituacao`, regiao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}